import { render, staticRenderFns } from "./notificationDialog.vue?vue&type=template&id=2d84facb&scoped=true&"
import script from "./notificationDialog.vue?vue&type=script&lang=js&"
export * from "./notificationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d84facb",
  null
  
)

export default component.exports